import { DC } from "../../constants";

export const effarigUnlocks = {
  adjuster: {
    id: 0,
    description: "Изменяемые коэффициенты уровня Глифов",
    cost: 1e7,
    onPurchased: () => {
      Effarig.quotes.unlockWeights.show();
      ui.view.tabs.reality.openGlyphWeights = true;
      Tab.reality.glyphs.show();
    }
  },
  glyphFilter: {
    id: 1,
    description: "Фильтрация Глифов",
    cost: 2e8,
    onPurchased: () => {
      Effarig.quotes.unlockGlyphFilter.show();
      player.reality.showSidebarPanel = GLYPH_SIDEBAR_MODE.FILTER_SETTINGS;
    }
  },
  setSaves: {
    id: 2,
    description: "Пресеты Глифов",
    cost: 3e9,
    onPurchased: () => {
      Effarig.quotes.unlockSetSaves.show();
      player.reality.showSidebarPanel = GLYPH_SIDEBAR_MODE.SAVED_SETS;
    }
  },
  run: {
    id: 3,
    description: "Реальность Эффарига",
    cost: 5e11,
    onPurchased: () => {
      Effarig.quotes.unlockRun.show();
    }
  },
  infinity: {
    id: 4,
    label: "Бесконечность",
    get description() {
      return ` Ограничение Репликантов умножается на значение, основанное на Бесконечностях
        Бесконечности увеличивают максимальное количество Галактик Репликантов
        Основной заработок Очков Бесконечности ограничен до ${format(DC.E200)} в Реальности Эффарига
        Каждый тип множителя Очков Бесконечности ограничен до ${format(DC.E50)} в Реальности Эффарига`;
    },
  },
  eternity: {
    id: 5,
    label: "Вечность",
    get description() {
      return ` Вечности генерирует Бесконечности
        Очки Бесконечности больше никак не ограничены в Реальности Эффарига
        Вы разблокировали Безымянных`;
    },
  },
  reality: {
    id: 6,
    label: "Реальность",
    get description() {
      return " Вы разблокировали Глиф Эффарига (можно экипировать только один, а некоторые эффекты взаимоисключающие)";
    },
  }
};
